import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { companiesService } from '../api/companies.service';

/** Operational usage stats for a single company (detail page). */
export function useCompanyDetailStatsQuery(companyId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.companies.detailStats(companyId ?? ''),
    queryFn: async () => {
      const res = await companiesService.getStats(companyId!);
      return res.stats ?? null;
    },
    enabled: !!companyId,
  });
}
